import MainSection from "./sections/main-section/main";
import FooterSection from "./sections/footer-section/footer";

import "./App.css";

function App() {
  return (
    <div className="container">
      <MainSection />
      <FooterSection />
    </div>
  );
}

export default App;
